import { render, staticRenderFns } from "./ShopsFilter.vue?vue&type=template&id=2ca5d206&scoped=true&"
import script from "./ShopsFilter.vue?vue&type=script&lang=js&"
export * from "./ShopsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ShopsFilter.vue?vue&type=style&index=0&id=2ca5d206&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca5d206",
  null
  
)

export default component.exports